/**
 * CloudBase SDK Initialization
 * 腾讯云 CloudBase SDK 初始化
 */

import cloudbase from "@cloudbase/js-sdk";

// 从环境变量获取配置
const ENV_ID = import.meta.env.VITE_CLOUDBASE_ENV_ID;

if (!ENV_ID) {
  console.warn(
    "[CloudBase] ENV_ID not configured. Please set VITE_CLOUDBASE_ENV_ID in .env file",
  );
}

/**
 * Initialize CloudBase App
 */
export const app = cloudbase.init({
  env: ENV_ID || "",
});

/**
 * Get Auth Instance
 */
export const auth = app.auth();

/**
 * Check if CloudBase is properly configured
 */
export const isCloudBaseConfigured = (): boolean => {
  return !!ENV_ID;
};
